import type { SpartacuxProductDiscoveryDomainState } from '@/domains/productDiscovery/productDiscovery.model';
import type { SponsoredRecommendationPlaylist } from '@/domains/productDiscovery/SponsoredProductRecommendation/interfaces/SponsoredProductRecommendation.model';

import type { MabayaProducts } from '../interfaces/MabayaProduct';

export const selectSponsoredProductRecommendation = (
  state: Partial<SpartacuxProductDiscoveryDomainState>,
): SponsoredRecommendationPlaylist | undefined =>
  state.productDiscovery?.sponsoredProductRecommendation
    ?.sponsoredRecommendations;

export const selectSponsoredProductIds = (
  state: Partial<SpartacuxProductDiscoveryDomainState>,
): MabayaProducts[] | undefined =>
  state.productDiscovery?.sponsoredProductRecommendation?.mabayaProducts;

export const selectSponsoredProductFetch = (
  state: Partial<SpartacuxProductDiscoveryDomainState>,
): boolean | undefined =>
  state.productDiscovery?.sponsoredProductRecommendation?.fetchingProducts ||
  state.productDiscovery?.sponsoredProductRecommendation?.fetchingIds;
